import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import selectSizePplus from './selectSizePplus/selectSizePplus.js'

export default contract({
  selectSizePplus: array([
    selectSizePplus
  ]),
})